import {
  IconAlertCircle,
  IconAlertTriangle,
  IconBriefcase,
  IconBuilding,
  IconCalendarCheck,
  IconChartLine,
  IconFileText,
  IconInbox,
  IconLayoutGrid,
  IconMapPin,
  IconPresentation,
  IconServer,
  IconSettings,
  IconSpeakerphone,
  IconUsersGroup,
  type Icon,
} from "@tabler/icons-react";

export type NavRechte = {
  canSeeBcg: boolean;
  canManage: boolean;
  /** Wie canManage, dazu Geschäftsleitung (Route /datenluecken). */
  canSeeDatenluecken: boolean;
  isServiceLead: boolean;
  canSeeMaintenance: boolean;
  canSeeCustomerView: boolean;
};

export type NavEintrag = {
  to: string;
  labelKey: string;
  icon: Icon;
  exact?: boolean;
};

export type NavGruppe = {
  key: "regeltermine" | "kunden" | "kennzahlen" | "verwaltung";
  labelKey: string;
  eintraege: NavEintrag[];
};

/** Menue nach Arbeitsweise gruppiert (Entwurf Hendrik, 2026-11-04). Die
 * Rechte-Flags blenden nur Eintraege aus; die echte Grenze ziehen Router
 * (RequireRole) und Server. `/inbox` ist bewusst nicht im Menue, sie ist ueber
 * "Mein Bereich" auf der Startseite erreichbar. */
export function baueNavigation(r: NavRechte): {
  start: NavEintrag;
  gruppen: NavGruppe[];
} {
  const start: NavEintrag = {
    to: "/",
    labelKey: "nav.dashboard",
    icon: IconInbox,
    exact: true,
  };
  const gruppen: NavGruppe[] = [
    {
      key: "regeltermine",
      labelKey: "nav.gruppe.regeltermine",
      eintraege: [
        { to: "/teamdaily", labelKey: "nav.teamDaily", icon: IconUsersGroup },
        { to: "/weekly", labelKey: "nav.weekly", icon: IconCalendarCheck },
      ],
    },
    {
      key: "kunden",
      labelKey: "nav.gruppe.kunden",
      eintraege: [
        ...(r.canSeeCustomerView
          ? [{ to: "/customer-view", labelKey: "nav.customerView", icon: IconPresentation }]
          : []),
        { to: "/statusberichte", labelKey: "nav.statusReports", icon: IconFileText },
        { to: "/visits", labelKey: "nav.visits", icon: IconMapPin },
        ...(r.canSeeMaintenance
          ? [{ to: "/wartung", labelKey: "nav.wartung", icon: IconServer }]
          : []),
        { to: "/campaigns", labelKey: "nav.campaigns", icon: IconSpeakerphone },
      ],
    },
    {
      key: "kennzahlen",
      labelKey: "nav.gruppe.kennzahlen",
      eintraege: [
        ...(r.canSeeBcg
          ? [{ to: "/kpi/bereich", labelKey: "nav.kpi", icon: IconChartLine }]
          : []),
        ...(r.isServiceLead
          ? [{ to: "/kpi/portfolio", labelKey: "nav.kpiPortfolio", icon: IconBriefcase }]
          : []),
        ...(r.canSeeBcg
          ? [
              { to: "/bcg", labelKey: "nav.bcg", icon: IconLayoutGrid },
              { to: "/kpi/ausreisser", labelKey: "nav.kpiOutliers", icon: IconAlertTriangle },
            ]
          : []),
      ],
    },
    {
      key: "verwaltung",
      labelKey: "nav.gruppe.verwaltung",
      eintraege: [
        { to: "/customers", labelKey: "nav.customers", icon: IconBuilding },
        ...(r.canSeeDatenluecken
          ? [{ to: "/datenluecken", labelKey: "nav.datenluecken", icon: IconAlertCircle }]
          : []),
        ...(r.canManage
          ? [{ to: "/settings", labelKey: "nav.settings", icon: IconSettings }]
          : []),
      ],
    },
  ];
  return { start, gruppen: gruppen.filter((g) => g.eintraege.length > 0) };
}
